import { render, staticRenderFns } from "./createUnion.vue?vue&type=template&id=427439e3&scoped=true&"
import script from "./createUnion.vue?vue&type=script&lang=js&"
export * from "./createUnion.vue?vue&type=script&lang=js&"
import style0 from "./createUnion.vue?vue&type=style&index=0&id=427439e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427439e3",
  null
  
)

component.options.__file = "createUnion.vue"
export default component.exports